import { FancyToggle, FancyRadio } from 'apps/builder/components/settings/modal'
import { SettingsFieldSelect } from 'apps/builder/components/settings/modal/shared'
import { useDispatch } from 'react-redux'
import { updateEntry } from 'apps/builder/store/actions/entries'
import { RequiredToggle } from 'apps/builder/components/settings/modal/shared'
import { useSelector } from 'react-redux'
import { builderTypeSelector } from 'apps/builder/store/selectors'

export const PhotoField = ({
  guid,
  label,
  length = 0,
  required,
  default: defaultValue,
  original_type_id,
  mask,
  type,
  keyField,
}) => {
  const photoCap = length !== null && length > 0 ? length : 0
  const dispatch = useDispatch()
  const isWebForm = useSelector(builderTypeSelector) === 'web-form'

  return (
    <>
      <div className="settings--row">
        <SettingsFieldSelect
          guid={guid}
          label={label}
          keyField={keyField}
          type={type}
        />

        <div className="toggles-group">
          <div className="toggle-wrapper">
            <RequiredToggle guid={guid} active={required} />
          </div>
          {!isWebForm && (
            <div className="toggle-wrapper">
              <FancyToggle
                label="Allow drawing on photo(s)"
                id={guid}
                id={`${guid}--drawing`}
                active={mask === '10'}
                inlineBorderStyle={true}
                onChange={checked => {
                  dispatch(
                    updateEntry({
                      guid,
                      mask: checked ? '10' : '',
                    })
                  )
                }}
              />
            </div>
          )}
        </div>
      </div>

      <div className="settings--format--wrapper">
        <label className="settings--label">Style</label>
        <FancyRadio
          id={`${guid}-1`}
          label={'Single Photo'}
          selected={original_type_id}
          value={10}
          onChange={(checked, value) => {
            checked
              ? (() => {
                  dispatch(
                    updateEntry({
                      guid,
                      original_type_id: value,
                      entry_type_id: 20,
                      length: 0,
                      style: 0,
                    })
                  )
                })()
              : ''
          }}
        />
        <FancyRadio
          id={`${guid}-2`}
          label={'Multiple Photos'}
          selected={original_type_id}
          value={25}
          onChange={(checked, value) => {
            checked
              ? (() => {
                  dispatch(
                    updateEntry({
                      guid,
                      original_type_id: value,
                      entry_type_id: 119,
                      length: 10,
                      inserts_page_break_at_the_end: false,
                      uses_caption_format: false,
                      style: 0,
                    })
                  )
                })()
              : ''
          }}
        />{' '}
        {original_type_id == 25 ? (
          <div className="label--context">
            Note: Users can take up to {photoCap} photos
          </div>
        ) : (
          ''
        )}
      </div>
    </>
  )
}
